export default "__VITE_ASSET__CdbJ$Kdt__"